import * as React from "react";
import {
  WidgetFrame,
  ProgressWidget,
  ErrataWidget,
  FormJSON,
} from "../../../personal-studio-components/studio";
import { Table } from "../../../personal-studio-components/table";
import { Dialog } from "../../../personal-studio-components/component/Dialog.jsx";
import { ChatRoom } from "./ChatRoom.jsx";
// eslint-disable-next-line no-unused-vars
import { QuestionsModel } from "./QuestionsModel.js";
//import * as cls from "./Questions.module.scss";
export { QuestionsView };
/**
 * Вид страницы "Консультации".
 * @param {Object} props - Атрибуты компонента.
 * @param {QuestionsModel} props.model - Модель страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function QuestionsView({ model, progress, errorFiles, setErrorFiles }) {
  const menu = model.getMenu();
  const schema = model.getSchema();
  return (
    <WidgetFrame icon={model.icon} title={model.title} menu={menu}>
      <Table {...model.table} />
      <Dialog
        title={schema.title}
        open={model.open}
        onClose={(e) => {
          model.onClick(e);
          setErrorFiles(null);
        }}
      >
        <FormJSON
          errorFiles={errorFiles}
          setErrorFiles={setErrorFiles}
          schema={schema}
          progress={progress}
        />
      </Dialog>
      <ChatRoom
        question_tutor_id={model.chat_room}
        onClose={model.onCloseChatRoom}
      />
    </WidgetFrame>
  );
}
/**
 * Вид загрузчика страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {string} props.title - Заголовок страницы.
 * @returns {JSX.Element} Элемент JSX.
 */
QuestionsView.LoaderView = ProgressWidget;
/**
 * Вид отчёта об ошибке загрузки страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 */
QuestionsView.ErrataView = ErrataWidget;
